<template>
    <div>
        <!-- 面包屑组件 -->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
            <el-breadcrumb-item>财务中心</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path:'/salaryList'}">工资管理</el-breadcrumb-item>
            <el-breadcrumb-item>工资规则</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 内容卡片 -->
        <el-card>
            <!-- 查询框 -->
            <el-row :gutter="24">
                <el-col :span="4">
                    <el-input
                        v-model="queryInfo.realname"
                        placeholder="请输入老师姓名"
                        clearable
                    >
                    </el-input>
                </el-col>
                <el-col :span="10">
                    <el-button @click="handleSearch" type="primary">搜索</el-button>
                    <el-button @click="handleClear" type="warning">清空</el-button>
                </el-col>
            </el-row>
            <el-table :data="dataList"  @selection-change="handleSelectionChange" stripe>
                <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                <el-table-column label="上课老师" prop="realname"></el-table-column>
                <el-table-column label="手机号码"  prop="phone"></el-table-column>
                <el-table-column label="基本工资"  prop="baseSalary"></el-table-column>
                <el-table-column label="扣除金额"  prop="deductSalary"></el-table-column>
                <el-table-column label="岗位级别"  prop="postionLevelDesc"></el-table-column>
                <el-table-column label="岗位系数"  prop="postionRation"></el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button @click="handleEdit(scope.row)" type="text">去设置</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 页数码 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNo"
                :page-sizes="[10, 15, 20, 25, 30, 35]"
                :page-size="queryInfo.pageSize"
                :total="total"
                background
            ></el-pagination>
        </el-card>
        <el-dialog
            :title="editData.id?editData.realname+'工资规则设置':'新增'"
            :visible.sync="addEditModalShow"
            :close-on-click-modal="false"
            width="30%"
        >
            <el-form :label-position="'right'" label-width="90px">
                <el-form-item label="基本工资" prop="baseSalary">
                    <el-input v-model="fromData.baseSalary"></el-input>
                </el-form-item>
                <el-form-item label="扣除金额" prop="deductSalary">
                    <el-input v-model="fromData.deductSalary"></el-input>
                </el-form-item>
                <el-form-item label="岗位名称" prop="postion">
                    <el-select v-model="fromData.postion" placeholder="请选择">
                        <el-option
                            v-for="item in postionList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="岗位级别" prop="postionLevel">
                    <el-select v-model="fromData.postionLevel" placeholder="请选择">
                        <el-option
                            v-for="item in postionLevelList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="岗位系数" prop="postionRation">
                    <el-input v-model="fromData.postionRation"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addEditModalShow = false">取 消</el-button>
                <el-button type="primary" @click="handleOk()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return{
                dataList: [],
                queryInfo: {
                    realname: '',
                    pageSize: 10,
                    pageNo: 1,
                },
                fromData:{
                    id:'',
                    baseSalary:'',
                    deductSalary:'',
                    postion:'',  //岗位
                    teacherId:'',
                    postionLevel:'',
                    postionRation:''
                },
                total: 0,
                selectList: [],
                postionLevelList:[
                    { label:'名师2',value: 1 },
                    { label:'名师1',value: 2 },
                    { label:'优秀2',value: 3 },
                    { label:'优秀1',value: 4 },
                    { label:'骨干2',value: 5 },
                    { label:'骨干1',value: 6 },
                    { label:'全职',value: 7 }
                ],
                postionList: [
                    { label:'学管师',value: 1 },
                    { label:'老师',value: 2 }
                ],
                addEditModalShow:false,
                editData:[]
            }
        },
        mounted() {
            this.initData();
        },
        methods:{
            async initData() {
                const { data: res } = await this.$http.post("/ea/teacher/salaryRule/list",this.queryInfo);
                    if(res.code == 200){
                        this.dataList = res.result.records;
                        this.total = res.result.total;
                    }else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type:'error'
                        });
                    }
            },
            handleSearch() {
                this.initData();
            },
            handleClear() {
                this.queryInfo.realname = null;
            },
            handleSelectionChange(val) {
                this.selectList = val;
            },
            // 套装页码切换
            handleCurrentChange(pageNum){
                this.queryInfo.pageNo = pageNum;
                this.initData();
            },
            handleSizeChange(val) {
                this.queryInfo.pageSize = val;
            },
            handleEdit(record) {
                this.editData = record;
                this.addEditModalShow = true;
                this.fromData = {
                    id:record.id,
                    baseSalary:record.baseSalary,
                    deductSalary:record.deductSalary,
                    postion:record.postion,  //岗位
                    teacherId:record.teacherId,
                    postionLevel:record.postionLevel,
                    postionRation:record.postionRation
               }
            },
            handleOk() {
                this.$http.post("/ea/teacher/salary/edit",this.fromData).then((res) => {
                    let data = res.data;
                    if(data && data.code == 0 || data.code == 200){
                        this.$message({
                            message: '设置成功',
                            type:'success'
                        });
                        this.addEditModalShow = false;
                        this.initData();
                    }else {
                        this.$message({
                            showClose: true,
                            message: data.message,
                            type:'error'
                        });
                    }
                })
            },
            // postionLevelType(val) {
            //     let arr = this.postionLevelList.filter((item) => { return val == item.value});
            //     return arr.label;
            // }
        }
    }
</script>

<style scoped>

</style>
